import { transformDateValue } from 'core/js/FormUtils';
export const getRawmaterialView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let rawmaterialList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          rawmaterialList.push(card);
  })
  return rawmaterialList;
}